import React, {
  useContext,
  useState,
  Fragment,
  useEffect,
  useCallback,
} from "react"
import { RootContext } from "RootContext"

// pegaso views/components
import Card from "components/Card/Card.js"
import CardBody from "components/Card/CardBody.js"
import CardHeader from "components/Card/CardHeader.js"
import ErrorUtils from "components/Tools/ErrorUtils"
import ScrollUtils from "components/Tools/ScrollUtils.js"
import { fetchWithToken } from "components/Fetch/api-fetch"

// Core components
import Button from "@material-ui/core/Button"
import CircularProgress from "@material-ui/core/CircularProgress"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogContentText from "@material-ui/core/DialogContentText"
import DialogTitle from "@material-ui/core/DialogTitle"
import Grid from "@material-ui/core/Grid"
import MenuItem from "@material-ui/core/MenuItem"
import TextField from "@material-ui/core/TextField"
import { makeStyles } from "@material-ui/core/styles"

/*---------  import CSS ---------*/
import { useJobStyles, useJobStylesText } from "styles/job/jobCss"

// Griglia per scheda del JobRouting
function JobRoutingGridContainer(props) {
  const {
    t,
    apiUrl,
    companyId,
    getLab,
    labScopes,
    access_token,
    refresh_token,
    setAccess_token,
  } = useContext(RootContext)

  const { labId } = getLab()


  const classes = useJobStyles()
  const classesText = useJobStylesText() // TEXT
  const { jobId, year, onHandleClose } = props
  const [jobChecked, setJobChecked] = useState(false)
  const [jobErrorMsg, setJobErrorMsg] = useState("")
  const [supplier, setSupplier] = useState("")
  const [isSaving, setIsSaving] = useState(false)
  const [openDialog, setOpenDialog] = useState(false)
  const [dialogMsg, setDialogMsg] = useState("")
  const [orderRoute, setOrderRoute] = useState(true)
  const [routings, setRoutings] = useState()
  const [jobAlreadySent, setJobAlreadySent] = useState(false)
  const [openjobAlreadySent, setOpenJobAlreadySent] = useState(false)

  // Legge il job
  const fecthJob = useCallback(() => {
    const url = `${apiUrl}/companies/${companyId}/labs/${labId}/jobs/${jobId}?year=${year}`

    fetchWithToken(url, {
      method: "GET",
      apiUrl: apiUrl,
      companyId: companyId,
      access_token: access_token,
      refresh_token: refresh_token,
      setAccess_token: setAccess_token,
    })
      .then((response) => {
        return response.body // data
      })
      .then((data) => {
        // Controllo che esista forma (disattivato)
        //const { shape } = data
        //const { standard } = shape
        // if (!standard) {
        //   setJobErrorMsg(t("30"))
        // }
        // Controlla che il prodotto ci sia
        const { notes } = data
        const { lensProduct, lensOrderReference } = notes
        if (lensOrderReference !== "") {
          setJobAlreadySent(true)
          setOpenJobAlreadySent(true)
        }
        if (lensProduct) {
          if (lensProduct.indexOf("[") < 0) {
            setJobErrorMsg(t("46"))
          }
        } else {
          setJobErrorMsg(t("29"))
        }
        setJobChecked(true)
      })
      .catch((err) => {
        // Se Job non esiste
        setJobErrorMsg(t("35"))
        setJobChecked(true)
        ErrorUtils.errorLog(`${url} => fecthJob Error`, err.message)
      })
  }, [
    access_token,
    apiUrl,
    companyId,
    jobId,
    labId,
    refresh_token,
    setAccess_token,
    t,
    year,
  ])

  // Fà controlli sul job
  useEffect(() => {
    if (!jobChecked) {
      fecthJob()
    }

    // Solo utente laboratorio con labScope = 8 attivo vede il bottone
    if (orderRoute) {
      let labScopeSelected = []
      let route = undefined
      let supplier = undefined
      let labSettings = []

      if (labScopes) {
        labScopeSelected = labScopes.filter((elem) => {
          return elem.active === true && elem.scopeId === 8
        })

        if (labScopeSelected.length > 0) {
          labSettings = labScopeSelected[0].labSettings
          if (labSettings) {
            route = labSettings.routings
          }
        }
      }

      if (route) {
        if (route.length > 0) {
          route.sort(function (a, b) {
            if (a.supplierCode >= b.supplierCode) {
              return 1
            } else {
              return -1
            }
          })
          supplier = route[0].supplierCode
        }
      }

      if (!supplier) {
        setJobErrorMsg(t("44"))
      }

      setRoutings(route)
      setSupplier(supplier)
      setOrderRoute(false)
    }
  }, [fecthJob, jobChecked, labScopes, orderRoute, t])

  // Handle Supplier Change
  const handleSupplierChange = (event) => {
    const value = event.target.value
    setSupplier(value)
  }

  // Handle Save Button
  const handleSave = () => {
    if (supplier) {
      setIsSaving(true)

      // Inoltro job a "Pegaso-Routing"
      const url = `${apiUrl}/companies/${companyId}/labs/${labId}/jobs/${jobId}/routing/${supplier}?year=${year}`
      fetchWithToken(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
        apiUrl: apiUrl,
        companyId: companyId,
        access_token: access_token,
        refresh_token: refresh_token,
        setAccess_token: setAccess_token,
      })
        .then((response) => {
          return response.body // => data
        })
        .then((data) => {
          // Chiudo job.
          setDialogMsg(t("10239"))
          setOpenDialog(true)
          setIsSaving(false)
        })
        .catch((err) => {
          ErrorUtils.errorLog(`handleSave Error`, err.message)
          setDialogMsg(t("42"))
          setOpenDialog(true)
          setIsSaving(false)
        })
    }
  }


  // Handle Save Button
  const onHandleContinue = () => {
    setOpenJobAlreadySent(false)
  }


  return (
    <div>
      <Card>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>{t("10234")}</h4>
        </CardHeader>
        <CardBody>
          {!jobErrorMsg && jobChecked && routings ? (
            <div>
              <ScrollUtils.ElevationScroll {...props}>
                <ScrollUtils.AppBarScroll {...props} t={t} />
              </ScrollUtils.ElevationScroll>
              <Grid
                container
                spacing={2}
                alignContent="flex-end"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <Grid item xs={12}>
                  {t("10235")}
                  {
                    <TextField
                      required
                      select
                      id={"supplier"}
                      label={""}
                      className={classesText.textField}
                      value={supplier}
                      onChange={handleSupplierChange}
                      SelectProps={{
                        MenuProps: {
                          className: classesText.menu,
                        },
                      }}
                    >
                      <MenuItem value=""></MenuItem>
                      {routings.map((option) => (
                        <MenuItem
                          key={option.supplierCode}
                          value={option.supplierCode}
                        >
                          {option.supplier}
                        </MenuItem>
                      ))}
                    </TextField>
                  }
                </Grid>
                <Grid item xs={4}>
                  <strong>{t("10050")}: </strong>
                  {jobId}
                </Grid>
                <Grid item xs={4}>
                  <strong>{t("10237")}: </strong>
                  {year}
                </Grid>
                <Grid item xs={4}>
                  <Button
                    disabled={supplier === ""}
                    variant="outlined"
                    color="secondary"
                    onClick={handleSave}
                  >
                    {t("10236")}
                  </Button>
                </Grid>
              </Grid>

              <Dialog
                open={isSaving || openDialog}
                onClose={onHandleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
                {openDialog ? (
                  <Fragment>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        {dialogMsg}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={onHandleClose} color="primary" autoFocus>
                        Ok
                      </Button>
                    </DialogActions>
                  </Fragment>
                ) : (
                  <Fragment>
                    <DialogContent>
                      <DialogContent>
                        <CircularProgress size={42} style={{ color: "primary" }} />
                      </DialogContent>
                    </DialogContent>
                  </Fragment>
                )}
              </Dialog>

              {jobAlreadySent && openjobAlreadySent ? (
                <Dialog
                  open={openjobAlreadySent}
                  onClose={onHandleClose}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
                  <Fragment>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        {t("10449")}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button
                        onClick={onHandleClose}
                        color="primary"
                      >
                        {t("10243")}
                      </Button>
                      <Button
                        onClick={onHandleContinue}
                        color="primary">
                        {t("10244")}
                      </Button>
                    </DialogActions>
                  </Fragment>
                </Dialog>
              ) : null}

            </div>
          ) : jobErrorMsg ? (
            <div>
              <ScrollUtils.ElevationScroll {...props}>
                <ScrollUtils.AppBarScroll {...props} t={t} />
              </ScrollUtils.ElevationScroll>
              {`${t("43")}: ${t("42")}`}
              <br />
              <br />
              {`${jobErrorMsg}`}
              <br />
              <br />
            </div>
          ) :
            (
              <CircularProgress className={classes.progress} />
            )}
        </CardBody>
      </Card>
    </div>)
}

// Griglia interna alla finestra del JobRouting
function JobRoutingSqs(props) {
  const { jobId, year } = props
  const useStyles = makeStyles((theme) => ({
    progress: {
      margin: theme.spacing(2),
    },
  }))
  const classes = useStyles()

  if (jobId && year) {
    return <JobRoutingGridContainer {...props} />
  } else {
    return <CircularProgress className={classes.progress} />
  }
}

export default JobRoutingSqs
